import { render, staticRenderFns } from "./dp-screen-cover.vue?vue&type=template&id=a5c71e26"
import script from "./dp-screen-cover.vue?vue&type=script&lang=js"
export * from "./dp-screen-cover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports